import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router";
import Select from "react-select";
import axios from "axios";
import { API, baseURL } from "../../services/api";
import $ from "jquery";
import OrgContext from "../../organisation/OrgContext";
import AuthContext from "../../components/shared/AuthContext";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment/moment";
import Swal from "sweetalert2";
import NewClient from "../Items/NewClient";
import { useTranslation } from "react-i18next";

const EditInvoiceAchat = (props) => {
  const { id } = useParams();

  const navigate = useNavigate();
  const [t, i18n] = useTranslation();

  const [client, setClient] = useState([]);
  const [invoiceCreatedAt, setInvoiceCreatedAt] = useState("");
  const [invoiceDueDate, setInvoiceDueDate] = useState("");
  const { organisation, changeOrg } = useContext(OrgContext);
  const { user, logout } = useContext(AuthContext);
  const [clients, setClients] = useState([]);
  const [clientToEditId, setClientToEditId] = useState(0);
  const [invoice, setInvoice] = useState([]);
  const [objet, setObjet] = useState("");
  const [autoIncrementInvoiceNumber, setAutoIncrementInvoiceNumber] =
    useState(false);
  const [invoiceProductsState, setInvoiceProductsState] = useState([]);
  const [productIsChanged, setProductIsChanged] = useState(false);
  const [productIdToEdit, setProductIdToEdit] = useState(0);
  const [invoiceProducts, setInvoiceProducts] = useState([]);
  const [products, setProducts] = useState([]);

  const [qty, setQty] = useState(0);
  const [singleSelectedProduct, setSingleSelectedProduct] = useState([]);
  const [unitPrice, setUnitPrice] = useState(0);
  const [selectedProductQty, setSelectedProductQty] = useState(0);
  const [tva, setTva] = useState(0);
  const [totalHt, setTotalHt] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [productDetails, setProductDetails] = useState(""); // Added state for product details

  //invoice status history
  const [invoiceStatusHistory, setInvoiceStatusHistory] = useState([]);
  const [invoiceStatus, setInvoiceStatus] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [invoiceStatusCreatedAt, setInvoiceStatusCreatedAt] = useState("");
  const [banqueAccounts, setBanqueAccounts] = useState([]);
  const [bqAccountId, setBqAccountId] = useState(0);
  const [banquePaymentOption, setBanquePaymentOption] = useState("");
  const [chequeId, setChequeId] = useState("");
  const [effetId, setEffetId] = useState("");
  const [payedAmount, setPayedAmount] = useState(0);
  const [invoiceProductsToDelete, setInvoiceProductsToDelete] = useState([]);
  const [reloadState, setReloadState] = useState(0);

  const leTotalHt = useRef(0);
  const leTotalTTc = useRef(0);

  //summary
  const [summaryTotatlHt, setSummaryTotatlHt] = useState(0);
  const [summaryTotalTva, setSummaryTotalTva] = useState(0);
  const [summaryTotatlTtc, setSummaryTotatlTtc] = useState(0);

  //facture achat
  const [product, setProduct] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [selectedPurchaseAccount, setSelectedPurchaseAccount] = useState([]);
  const [purchaseAccounts, setPurchaseAccounts] = useState([]);
  const [purchaseAccount, setPurchaseAccount] = useState([]);
  const [remarque, setRemarque] = useState([]);
  const remarqueRef = useRef("");
  const [invoiceRap, setInvoiceRap] = useState(0);
  const [caisseAccountId, setCaisseAccountId] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);

  // sous compte comptable des paiement
  const [sousCompte, setSousCompte] = useState("");
  const [sousCompteCs, setSousCompteCs] = useState("");
  const [sousComptes, setSousComptes] = useState([]);
  const [sousComptesCs, setSousComptesCs] = useState([]);
  const [totalTTc, setTotalTTC] = useState();
  const [isService, setIsService] = useState(false);

  // depots
  const [selectedDepotId, setSelectedDepotId] = useState("");
  const [productDepots, setProductDepots] = useState([]);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    calcInvoiceSummary();
  }, [invoiceProductsState]);
  const calcInvoiceSummary = () => {
    let totalHt = 0;
    let totalTva = 0;
    let totalTtc = 0;

    for (let i = 0; i < invoiceProductsState.length; i++) {
      totalHt += parseFloat(invoiceProductsState[i].total_ht);
      totalTtc += parseFloat(invoiceProductsState[i].total_ttc);
      totalTva +=
        parseFloat(invoiceProductsState[i].total_ttc) -
        parseFloat(invoiceProductsState[i].total_ht);
    }
    setSummaryTotatlHt(totalHt);
    setSummaryTotalTva(totalTva);
    setSummaryTotatlTtc(totalTtc);
  };

  useEffect(() => {
    if (invoice && invoice.length !== 0) {
      setLoaded(true);
    }
  }, [invoice]);


  const fetchSousAccounts = async () => {
    await jwtInterceoptor
      .get("/data/user/bq/accounts/" + organisation.id)
      .then((res) => {
        setSousComptes(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchSousAccountsCs = async () => {
    await jwtInterceoptor
      .get("/data/user/cs/accounts/" + organisation.id)
      .then((res) => {
        setSousComptesCs(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const editSingleInvoiceProduct = () => {
    if (
      selectedProduct.value === null ||
      qty === 0 ||
      unitPrice === 0 ||
      leTotalHt.current.value === 0 ||
      leTotalTTc.current.value === 0
    ) {
      toast.error("Tous les champs sont obligatoire !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      hideOffcanvas();
      for (let i = 0; i < invoiceProductsState.length; i++) {
        if (invoiceProductsState[i].product_id === productIdToEdit) {
          invoiceProductsState[i].qty = qty;
          invoiceProductsState[i].unitPrice = unitPrice;
          invoiceProductsState[i].totalHt = totalHt;
          invoiceProductsState[i].total_ht = totalHt;
          invoiceProductsState[i].totalTtc = totalTTc;
          invoiceProductsState[i].total_ttc = totalTTc;
          invoiceProductsState[i].details = productDetails; // Update product details
          invoiceProductsState[i].name =
            `${singleSelectedProduct.label} - ${productDetails}`; // Concatenate name with details
          invoiceProductsState[i].depot_id = selectedDepotId;
        }
      }
      setInvoiceProductsState([...invoiceProductsState]);
      setProductDetails(""); // Reset details field
    }
    console.log("invoiceProductsState after edit: ", invoiceProductsState);
  };

  const [depotsProduct, setDepotsProduct] = useState([]);
  const getProductData = async (selectedProduct) => {
    //selectedProduct
    const response = await axios
      .get(baseURL + `/product/get/${selectedProduct.value}`)
      .then((response) => {
        //setSingleSelectedProduct(transformProductsArray(response.data.data))
        setUnitPrice(response.data.data[0]["costPrice"]);
        if (selectedProduct?.isService) {
          setIsService(true);
          setQty(1);
        } else {
          setQty(0);
        }
        console.log(
          "response.data.dataresponse.data.dataresponse.data.data: ",
          response.data.data,
        );
        setSelectedProductQty(response.data.data.qty);
        setTva(response.data.data[0]["taxe_achat"].rate);
        setDepotsProduct(response.data.data[0].depot);
        setProductDetails("");
      })
      .catch((error) => console.log("error " + error));
  };

  const [selectedAttachment, setSelectedAttachment] = useState(null);
  const fileAtta = useRef();
  const onFileUpload = (event) => {
    if (event.target?.files[0]) {
      console.log("event.target.files[0] : " + event.target.files[0]);
      setSelectedAttachment(event.target.files[0]);
    } else {
      console.log("else");
    }
  };

  useEffect(() => {
    $(".invoiceStatus").css("display", "none");
    $(".all-fields-are-required-to-save").css("display", "none");
    $("#warning-create-client-first").css("display", "none");
    $("#table-rows").css("display", "none");
    $("#all-fields-are-required").css("display", "none");
    $("#warning-product-already-exists").css("display", "none");
    $("#qty-is-higher").css("display", "none");

    //
    getAllAssociatedProducts();
    //
    getInvoiceStatusHistory();
    // getAllAssociatedClients();
    getInvoiceProducts();
    calcInvoiceSummary();
    getInvoiceStatus();
    getAccounts();
    fetchSousAccounts();
    fetchSousAccountsCs();
  }, []);

  useEffect(() => {
    $(".all-fields-are-required-to-save").css("display", "none");
    $("#warning-create-client-first").css("display", "none");
    $("#table-rows").css("display", "none");
    $("#all-fields-are-required").css("display", "none");
    $("#warning-product-already-exists").css("display", "none");
    $("#qty-is-higher").css("display", "none");

    getAllAssociatedProducts();
    getInvoiceStatusHistory();
    // getAllAssociatedClients();
    getInvoiceProducts();
    getAllAssociatedProducts();
    calcInvoiceSummary();
    getInvoiceStatus();
    getAccounts();
  }, [reloadState]);

  const getAccounts = async () => {
    await axios
      .get(baseURL + "/paymentAccounts")
      .then((response) => {
        setBanqueAccounts(response.data.data);
        response.data.data.map((a) => {
          if (a.name === "Banques (soldes débiteurs)") {
            setBqAccountId(a.id);
          } else if (a.name === "Caisses") {
            setCaisseAccountId(a.id);
          }
        });
        console.log("banque accout: ", banqueAccounts);
      })
      .catch((error) =>
        console.log("error while retrieving setBanqueAccounts : " + error),
      );
  };
  const getInvoiceStatus = async () => {
    const response = await API.get("/factures/status")
      .then((res) => {
        setInvoiceStatus(res.data.data);
        setData(res.data.data);
      })
      .catch((error) => console.log(error));
  };

  const getInvoiceStatusHistory = async () => {
    const response = await jwtInterceoptor
      .get(baseURL + `/data/user/invoice_achats_status_history/${id}`)
      .then((response) => {
        setInvoiceStatusHistory(response.data.data);
        if (response.data.data[response.data.data.length - 1].status.id === 2) {
          $(".addPaymentStatus").remove();
          $(".invoiceStatus").css("display", "block");
        }
      })
      .catch((error) =>
        console.log("error while retrieving products by user" + error),
      );
  };
  const getAllAssociatedProducts = async () => {
    let fst = {};
    let snd = {};
    let res_suppliers_response = {};
    let res_purchaseAccount_response = {};
    let res = {};
    let suppliers_response = {};
    let purchaseAccount_response = {};

    const response = await axios
      .get(baseURL + `/product/getbyuser/${user.id}/${organisation.id}`)
      .then((response) => {
        setProducts(transformArrayToOptions4Products(response.data.data));
        fst = transformArrayToOptions4Products(response.data.data);
      })
      .catch((error) =>
        console.log("error while retrieving products by user" + error),
      );

    const response2 = await jwtInterceoptor
      .get(`/data/user/factures_achat/byid/${id}`)
      .then((res) => {
        snd = res.data.data;

        setInvoice(res.data.data);
        setData(res.data.data);
      })
      .catch((error) => console.log(error));

    const response3 = await axios
      .get(
        baseURL +
          `/client/getbyuser/${user.id}/fournisseurs/${organisation.id}`,
      )
      .then((res) => {
        console.log("data ", res.data.data);
        setSuppliers(transformArrayToOptions(res.data.data));
        suppliers_response = transformArrayToOptions(res.data.data);
      })
      .catch((error) =>
        console.log("error while retrieving products by user" + error),
      );

    res_suppliers_response = suppliers_response.filter(
      (s) => s.value === snd.supplier_id,
    );

    setSupplier({
      value: res_suppliers_response[0]["value"],
      label: res_suppliers_response[0]["label"],
    });
  };

  const transformArrayToOptions = (target) => {
    let array = [];
    for (let i = 0; i < target.length; i++) {
      let obj = { value: target[i].id, label: target[i].companyName };
      array.push(obj);
    }
    return array;
  };

  const transformArrayToOptions4Products = (target) => {
    let array = [];
    for (let i = 0; i < target.length; i++) {
      let obj = {
                isService: target[i]?.type === "Marchandise" ? false : true,
        value: target[i].id,
        label: target[i].name,
        rate: target[i].taxe_achat.rate,
        compte_de_charge: target[i].purchase_account.name,
        code: target[i].purchase_account.code,
        depot: target[i].depot,
      };
      array.push(obj);
    }
    return array;
  };

  const transformProductsArray = (products) => {
    let array = [];
    for (let i = 0; i < products.length; i++) {
      let obj = { value: products[i].id, label: products[i].name };
      array.push(obj);
    }
    return array;
  };

  const getInvoiceProducts = async () => {
    const response = await jwtInterceoptor
      .get(baseURL + `/data/user/facture_achats_products/${id}`)
      .then((response) => {
        if (response.data.data.length === 0) {
        } else {
          const allProduct = response.data.data;
          let preparedProducts = [];
          for (let i = 0; i < allProduct.length; i++) {
            let obj = {
              product_id: allProduct[i].product_id,
              product: {
                name: allProduct[i].product.name,
                type: allProduct[i].product.type,
                sellingPrice: allProduct[i].product.sellingPrice,
                purchase_account: {
                  name: allProduct[i].product.purchase_account.name,
                  code: allProduct[i].product.purchase_account.code,
                },
              },
              qty: allProduct[i].qty,
              tva: allProduct[i].tva,
              totalHt: allProduct[i].total_ht,
              totalTtc: allProduct[i].total_ttc,
              details: allProduct[i].details, // Include product details
              depot_id: allProduct[i].depot_id,
            };
            preparedProducts.push(obj);
          }
          setInvoiceProductsState(response.data.data);
          console.log("setInvoiceProductsState: ", preparedProducts);
        }
      })
      .catch((error) => console.log("error " + error));
  };

  const setData = (invoice) => {
    //setDATA
    setInvoiceDueDate(invoice.due_date);
    setInvoiceNumber(invoice.invoice_number);
    setQty(invoice.qty);
    setRemarque(invoice.remarque);
    setInvoiceCreatedAt(invoice.created_at);
    setUnitPrice(invoice.price_ut);
    setSummaryTotatlHt(invoice.total);
    setSummaryTotatlTtc(invoice.total_ttc);
    setSummaryTotalTva(invoice.total_tva);
    setInvoiceRap(invoice.invoice_rap);
  };
  const editSingleProduct = (productId) => {
    $(".select-article").css("display", "none");
    $(".add-new-product-to-invoice-btn").css("display", "none");
    $(".edit-single-product").css("display", "revert");
    setProductIdToEdit(productId);
    let selectedProduct = [];
    selectedProduct = invoiceProductsState.filter(
      (p) => p.product_id === productId,
    );
    console.log(
      "selected product on click edit: ",
      selectedProduct[0].product.costPrice,
    );
    setIsService(selectedProduct[0].product.type === "Services");
    setTva(selectedProduct[0].tva);
    setQty(selectedProduct[0].qty);
    setUnitPrice(selectedProduct[0].total_ht / selectedProduct[0].qty);
    setTotalHt(selectedProduct[0].total_ht);
    setTotalTTC(selectedProduct[0].total_ttc);
    setSelectedDepotId(selectedProduct[0].depot_id);
    setProductDetails(selectedProduct[0].details); // Set product details
    setDepotsProduct(selectedProduct[0].product.depot);
  };
  const deleteSingleProduct = (productId) => {
    for (let i = 0; i < invoiceProductsState.length; i++) {
      if (invoiceProductsState[i].product_id === productId) {
        invoiceProductsState.splice(i, 1);
        setInvoiceProductsToDelete([...invoiceProductsToDelete, productId]);
      }
    }
    setInvoiceProductsState([...invoiceProductsState]);
    setProductIsChanged(true);
    const successMessage = "le produit a été supprimer avec succés";
    toast.success(successMessage, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const changeOfCanvasLayouts = () => {
    $("#all-fields-are-required").css("display", "none");
    $(".select-article").css("display", "block");
    $(".add-new-product-to-invoice-btn").css("display", "inline");
    $(".edit-single-product").css("display", "none");
    //reset value to default
    setSingleSelectedProduct([]);
    setQty(0);
    setUnitPrice(0);
    setTotalHt(0);
    setTva(0);
    setSelectedDepotId(0);
    setProductDetails(""); // Reset product details
  };

  const checkIfProductAlreadyExist = (productId) => {
    for (let i = 0; i < invoiceProductsState.length; i++) {
      if (invoiceProductsState[i].product_id === productId) {
        console.log("exist");
        return true;
      }
    }
    console.log("! exist");
    return false;
  };
  const hideOffcanvas = () => {
    const offcanvasElement = document.getElementById("offcanvasBottom");

    const offcanvas =
      window.bootstrap?.Offcanvas.getInstance(offcanvasElement) ||
      new window.bootstrap.Offcanvas(offcanvasElement);

    offcanvas.hide();
  };
  const emptyStates = () => {
    setSingleSelectedProduct([]);
    setQty(0);
    setUnitPrice(0);
    setTotalHt(0);
    setTotalTTC(0);
    setTva(0);
    setSelectedDepotId("");
    setProductDetails("");
  };
  const addNewProductToInvoice = async () => {
    emptyStates();
    if (
      selectedProduct.value === null ||
      qty === 0 ||
      unitPrice === 0 ||
      selectedDepotId === 0 ||
      productDetails.length === 0
    ) {
      const errorMessage = "Tous les champs sont obligatoire !";
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      if (checkIfProductAlreadyExist(singleSelectedProduct.value)) {
        const errorMessage = "Le produit déja exist !";
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        hideOffcanvas();
        /**
         * prepare product
         * @type {{unitPrice: number, qty: number, name, totalTtc, totalHt, tva: number}}
         */
        let product = {
          product_id: singleSelectedProduct.value,
          product: {
            name: singleSelectedProduct.label,
            sellingPrice: unitPrice,
            purchase_account: {
              name: singleSelectedProduct.compte_de_charge,
              code: singleSelectedProduct.code,
            },
          },
          qty: qty,
          tva: tva,
          total_ht: totalHt,
          total_ttc: totalTTc,
          productDetails: productDetails, // Include product details
          depot_id: parseInt(selectedDepotId),
        };
        setInvoiceProductsState([...invoiceProductsState, product]);
        setProductIsChanged(true);
        console.log("after click add new product, producs state is : ", [
          ...invoiceProductsState,
          product,
        ]);
      }
    }
  };

  const save = async () => {
    // check if all tab 1 inputs are !impty
    let isOkToEdit = true;
    isOkToEdit = !(
      supplier.length === 0 ||
      invoiceNumber.length === 0 ||
      invoiceCreatedAt.length === 0 ||
      invoiceProductsState.length === 0
    );
    console.log("1st: ", isOkToEdit);

    //etat= payé
    if (
      selectedStatus === "2" &&
      (paymentType.length === 0 || invoiceStatusCreatedAt.length === 0)
    ) {
      isOkToEdit = false;
    }
    if (
      selectedStatus === "2" &&
      paymentType.length !== 0 &&
      invoiceStatusCreatedAt.length !== 0
    ) {
      if (paymentType === caisseAccountId.toString()) {
        isOkToEdit = true;
      } else {
        if (banquePaymentOption.length === 0) {
          isOkToEdit = false;
        } else {
          if (banquePaymentOption === "chéque" && chequeId.length === 0) {
            isOkToEdit = false;
          }
        }
      }
    }

    console.log("2nd: ", isOkToEdit);

    //etat = payé en partie
    if (
      selectedStatus === "3" &&
      (paymentType.length === 0 || invoiceStatusCreatedAt.length === 0)
    ) {
      isOkToEdit = false;
    }
    if (
      selectedStatus === "3" &&
      paymentType.length !== 0 &&
      invoiceStatusCreatedAt.length !== 0
    ) {
      if (paymentType !== bqAccountId && payedAmount === 0) {
        isOkToEdit = false;
      } else {
        if (paymentType === bqAccountId && banquePaymentOption.length === 0) {
          isOkToEdit = false;
        } else {
          if (banquePaymentOption === "chéque" && chequeId.length === 0) {
            isOkToEdit = false;
          }
        }
      }
    }
    console.log("3th: ", isOkToEdit);

    if (
      selectedStatus === "3" &&
      paymentType.length !== 0 &&
      payedAmount === 0 &&
      invoiceStatusCreatedAt.length !== 0
    ) {
      isOkToEdit = false;
    }

    if (
      paymentType.length !== 0 &&
      paymentType === bqAccountId.toString() &&
      (sousCompte.length === 0 || sousCompte === 0)
    ) {
      isOkToEdit = false;
    }

    if (
      paymentType.length !== 0 &&
      paymentType === caisseAccountId.toString() &&
      (sousCompteCs.length === 0 || sousCompteCs === 0 || sousCompteCs === "0")
    ) {
      isOkToEdit = false;
    }

    if (isOkToEdit) {
      let preparedProducts = [];
      let statusIsChanged = false;
      for (let i = 0; i < invoiceProductsState.length; i++) {
        let obj = {
          product_id: invoiceProductsState[i].product_id,
          price_unit_ht:
            invoiceProductsState[i].product.type == "Services"
              ? invoiceProductsState[i].total_ht
              : parseFloat(
                  Number(
                    invoiceProductsState[i].total_ht /
                      invoiceProductsState[i].qty,
                  ).toFixed(2),
                ),
          qty: invoiceProductsState[i].qty,
          total_ht: invoiceProductsState[i].total_ht,
          total_ttc: invoiceProductsState[i].total_ttc,
          tva: invoiceProductsState[i].tva,
          reference: Math.random().toString(36).substring(2, 7),
          details: invoiceProductsState[i].details,
          depot_id: invoiceProductsState[i].depot_id,
        };
        preparedProducts.push(obj);
      }
      statusIsChanged = !(selectedStatus.length === 0);
      if (
        statusIsChanged &&
        selectedStatus === "1" &&
        invoiceStatusHistory[invoiceStatusHistory.length - 1]["status"][
          "id"
        ] !== 1
      ) {
        toast.error(
          "Impossible de changer le status d'une facture payé à créer",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
          },
        );
      } else {
        let theAccount = "";
        if (paymentType === bqAccountId.toString()) {
          theAccount = sousCompte;
        } else if (paymentType === caisseAccountId.toString()) {
          theAccount = sousCompteCs;
        } else {
          theAccount = paymentType;
        }

        const newStatusHistory = {
          statusIsChanged: statusIsChanged,
          status_id: selectedStatus,
          payment_account_id: theAccount,
          banquePaymentOption: banquePaymentOption,
          chequeId: chequeId,
          effetId: effetId,
          payed_amount: Number(payedAmount).toFixed(2),
          payed_invoice_created_at: invoiceStatusCreatedAt,
        };

        const prepareObject = {
          products: preparedProducts,
          invoice_id: id,
          organisation_id: organisation.id,
          product_id: product.value,
          account_id: purchaseAccount.value,
          supplier_id: supplier.value,
          total_ht: summaryTotatlHt,
          total_ttc: summaryTotatlTtc,
          total_tva: summaryTotalTva,
          remarque: remarque,
          invoice_created_at: invoiceCreatedAt,
          invoice_number: invoiceNumber,
          qty: qty,
          due_date: invoiceDueDate,
          price_ut: unitPrice,
          newStatusHistory: newStatusHistory,
          invoiceProductsToDelete: invoiceProductsToDelete,
          attachment_file: selectedAttachment,
          isProductsChanged: productIsChanged,
        };
        console.log("********");
        console.log("prepareObject: ", prepareObject);
        console.log("********");
        setIsSubmit(true);
        const response = await jwtInterceoptor
          .post(baseURL + `/data/user/facture_achat/edit`, prepareObject)
          .then((response) => {
            setIsSubmit(false);
            Swal.fire(
              "La facture d’achat a été modifiée avec succès",
              "",
              "success",
            );
            console.log("************* after save edit, ", response.data.data);
            navigate("/achat/factureachat/list");
          })
          .catch((error) => {
            setIsSubmit(false);
            console.log("error " + error);
          });
      }
    } else {
      const errorMessage = "Merci de remplir tout les champs obligatoire !";
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const handleInvoiceStatusCreatedAtChange = (e) => {
    const selectedDate = e.target.value;
    setInvoiceStatusCreatedAt(selectedDate);

    if (!invoiceDueDate) {
      toast.error("La date d'échéance n'est pas encore fixée !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      setInvoiceStatusCreatedAt("");
      return;
    }

    const createdAtDate = new Date(selectedDate);
    const dueDate = new Date(invoiceDueDate);

    if (createdAtDate < dueDate) {
      toast.warn(
        "la date de paiement que vous avez choisie est antérieure à la date d'échéance, Veuillez vérifier la date ou confirmer cette opération",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        },
      );
    }
  };

  const onSaveClient = () => {
    getAllAssociatedProducts();
    window.$("#newClientModal").modal("hide");
    console.log("has been saved");
    Swal.fire(t("Le fournisseur a été ajouter avec succès"), t(""), "success");
  };
  // annulation d'un payement
  const handleDeleteLastPayment = async () => {
    try {
      // Get the ID of the last payment
      const lastPaymentId =
        invoiceStatusHistory[invoiceStatusHistory.length - 1].id;
      const response = await jwtInterceoptor.delete(
        baseURL + `/data/users/facture_achat/payement/${lastPaymentId}`,
      );

      if (response.data.status) {
        console.log("Success:", response.data.data);
        getInvoiceStatusHistory();
        // Optionally, refresh your data or update your state here
      } else {
        console.log("Error:", response.data.data);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error:", error.response.data);
      } else if (error.request) {
        console.error("No response:", error.request);
      } else {
        console.error("Error:", error.message);
      }
    }
  };
  return (
    <>
      <ToastContainer />
      <div className="container-fluid">
        <div className="row" style={{ zIndex: 1 }}>
          <div className="col-lg-12">
            <div class="page-header">
              <h1 class="page-title">Modifier la facture</h1>
              <div>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a
                      href="javascript:void(0)"
                      onClick={() => navigate("/achat/factureachat/list")}
                    >
                      liste des factures d'achat
                    </a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    modifier
                  </li>
                </ol>
              </div>
            </div>
          </div>
          <div style={{ display: loaded ? "none" : "block" }}>
            <center>
              <div class="spinner-border text-primary me-2" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </center>
          </div>

          <div className="card" style={{ display: !loaded ? "none" : "block" }}>
            <div className="card-body">
              <div class="col-xl-12">
                <div class="panel panel-primary">
                  <div class="tab-menu-heading">
                    <div class="tabs-menu">
                      <ul class="nav panel-tabs panel-info">
                        <li>
                          <a
                            href="#tab21"
                            className="active"
                            data-bs-toggle="tab"
                          >
                            <span>
                              <i class=" me-1"></i>
                            </span>
                            Modifier la facture
                          </a>
                        </li>
                        <li>
                          <a href="#tab22" data-bs-toggle="tab" className="">
                            <span>
                              <i class=" me-1"></i>
                            </span>
                            Modifier le status
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="panel-body tabs-menu-body">
                    <div class="tab-content">
                      <div class="tab-pane active" id="tab21">
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1" className="">
                            Choisir le fournisseur*
                          </label>
                          <Select
                            value={supplier}
                            options={suppliers}
                            onChange={(choice) => setSupplier(choice)}
                          />
                        </div>
                        <a
                          className="btn btn-primary btn-sm"
                          data-bs-toggle="modal"
                          data-bs-target="#newClientModal"
                        >
                          <i className="fe fe-user"></i> ajouter un fournisseur
                        </a>
                        <div
                          class="modal fade"
                          id="newClientModal"
                          tabIndex="-1"
                          aria-labelledby="newClientModalLabel"
                          aria-hidden="true"
                        >
                          <div class="modal-dialog">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h1
                                  class="modal-title fs-5"
                                  id="newClientModal"
                                >
                                  Ajouter un nouveaux fournisseur
                                </h1>
                                <button
                                  type="button"
                                  className="btn-close"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                ></button>
                              </div>
                              <div class="modal-body">
                                <NewClient
                                  clientType={"fournisseurs"}
                                  from={"new_fv"}
                                  handleSave={onSaveClient}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                        <br />

                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1" className="">
                            N° de la facture*
                          </label>
                          <input
                            type="text"
                            placeholder="N° de la facture"
                            className={`form-control `}
                            onChange={(e) => setInvoiceNumber(e.target.value)}
                            value={invoiceNumber}
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1" className="">
                            date d'échéance*
                          </label>
                          <input
                            type="date"
                            placeholder="nom"
                            className={`form-control `}
                            onChange={(e) => setInvoiceDueDate(e.target.value)}
                            value={invoiceDueDate}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1" className="">
                            date de facture*
                          </label>
                          <input
                            disabled={invoice.status != 1}
                            type="date"
                            placeholder="nom"
                            className={`form-control `}
                            onChange={(e) =>
                              setInvoiceCreatedAt(e.target.value)
                            }
                            value={moment(invoiceCreatedAt).format(
                              "YYYY-MM-DD",
                            )}
                          />
                        </div>

                        <table className="table">
                          <thead>
                            <tr>
                              <th scope="col">DÉTAILS DE L’ARTICLE</th>
                              <th scope="col">COMPTE DE CHARGE DE L'ARTICLE</th>
                              <th scope="col">QUANTITÉ</th>
                              <th scope="col">PU HT</th>
                              <th scope="col">TVA %</th>
                              <th scope="col">Total HT</th>
                              <th scope="col">Total TTC</th>
                              <th scope="col"></th>
                              <th scope="col"></th>
                            </tr>
                          </thead>

                          {invoiceProductsState.map((product) => {
                            return (
                              <tr key={product.product_id}>
                                <td>{`${product.product.name} ${product.details == null || product.details === "" ? "" : "- " + product.details}  `}</td>
                                <td>
                                  {product.product.purchase_account.name +
                                    " - " +
                                    product.product.purchase_account.code}
                                </td>
                                <td>{product.qty}</td>
                                <td>{product.total_ht / product.qty}</td>
                                <td>{product.tva + "%"}</td>
                                <td>{product.total_ht}</td>
                                <td>{product.total_ttc}</td>
                                {invoice.status == 1 && (
                                  <>
                                    <td>
                                      <i
                                        onClick={() =>
                                          deleteSingleProduct(
                                            product.product_id,
                                          )
                                        }
                                        class="fe fe-trash"
                                      ></i>
                                    </td>
                                    <td>
                                      <i
                                        data-bs-toggle="offcanvas"
                                        aria-controls="offcanvasBottom"
                                        data-bs-target="#offcanvasBottom"
                                        onClick={() =>
                                          editSingleProduct(product.product_id)
                                        }
                                        class="fe fe-edit"
                                      ></i>
                                    </td>
                                  </>
                                )}
                              </tr>
                            );
                          })}
                        </table>
                        {invoice.status == 1 && (
                          <center>
                            <button
                              onClick={changeOfCanvasLayouts}
                              className="btn btn-primary off-canvas btn-sm mb-1"
                              type="button"
                              data-bs-toggle="offcanvas"
                              data-bs-target="#offcanvasBottom"
                              aria-controls="offcanvasBottom"
                            >
                              <i className="fe fe-plus"></i>
                              ajouter un article
                            </button>
                          </center>
                        )}
                        <div className="row">
                          <div className="invoiceSummary">
                            <table>
                              <tr>
                                <td className={"invoiceSummary-base"}>
                                  Total HT :
                                </td>
                                <td>
                                  {Number(summaryTotatlHt).toFixed(2)}{" "}
                                  {organisation?.currency?.code}
                                </td>
                              </tr>
                              <tr>
                                <td className={"invoiceSummary-base"}>
                                  Total TVA :
                                </td>
                                <td>
                                  {Number(summaryTotalTva).toFixed(2)}{" "}
                                  {organisation?.currency?.code}
                                </td>
                              </tr>
                              <tr>
                                <td className={"invoiceSummary-base"}>
                                  Total TTC :
                                </td>
                                <td>
                                  {Number(summaryTotatlTtc).toFixed(2)}{" "}
                                  {organisation?.currency?.code}
                                </td>
                              </tr>
                            </table>
                          </div>
                          <div class="form-group">
                            <label className="form-label">
                              Glissez ou déplacez la nouvelle piéce (
                              <span className="text-red">
                                Fichier PDF/Image, taille Max 2 Mo
                              </span>
                              )
                            </label>
                            <input
                              className="form-control form-control-lg"
                              type="file"
                              onChange={onFileUpload}
                              ref={fileAtta}
                            />
                          </div>
                        </div>
                      </div>
                      <div class="tab-pane" id="tab22">
                        <div className="statusHistoryWrapper">
                          <div class="container">
                            <ul class="notification">
                              {invoiceStatusHistory.map((invoiceStatus) => {
                                if (
                                  invoiceStatus.status.name ===
                                    "Payé en partie" ||
                                  invoiceStatus.status.name === "Payé"
                                ) {
                                  return (
                                    <li>
                                      <div class="notification-time">
                                        <span class="date"></span>
                                        <span class="time">
                                          {moment(
                                            invoiceStatus.created_at,
                                          ).format("DD/MM/YYYY")}
                                        </span>
                                      </div>
                                      <div class="notification-icon">
                                        <a href="javascript:void(0);"></a>
                                      </div>
                                      <div class="notification-time-date mb-2 d-block d-md-none">
                                        <span class="date">Today</span>
                                        <span class="time ms-2">02:31</span>
                                      </div>
                                      <div class="notification-body">
                                        <div class="media mt-0">
                                          <div class="media-body ms-3 d-flex">
                                            <div class="">
                                              <p class="fs-18 text-dark fw-bold mb-0">
                                                {invoiceStatus.status.name}
                                              </p>
                                              <div>
                                                <p
                                                  style={{
                                                    display:
                                                      invoiceStatus.payed_amount ===
                                                      "0"
                                                        ? "none"
                                                        : "block",
                                                  }}
                                                  className="mb-0 fs-13 text-dark"
                                                >
                                                  {invoiceStatus.status.name ===
                                                  "Payé"
                                                    ? `Mantant Payé: ${invoiceStatus.rap}`
                                                    : `Mantant Payé: ${invoiceStatus.payed_amount}${organisation?.currency?.code}`}
                                                </p>
                                                <p
                                                  style={{
                                                    display:
                                                      invoiceStatus.status
                                                        .name == "Payé"
                                                        ? "none"
                                                        : "block",
                                                  }}
                                                  class="mb-0 fs-13 text-dark"
                                                >
                                                  {"Réste à payé: " +
                                                    invoiceStatus.rap +
                                                    organisation?.currency
                                                      ?.code}
                                                </p>
                                                <p class="fs-13 text-dark fw-bold mb-0">
                                                  {invoiceStatus.payment_account
                                                    .code +
                                                    " - " +
                                                    invoiceStatus
                                                      .payment_account.name}
                                                </p>
                                                <p class="fs-13 text-dark fw-bold mb-0">
                                                  {invoiceStatus.banquePaymentOption ===
                                                  null
                                                    ? ""
                                                    : invoiceStatus.banquePaymentOption +
                                                      (invoiceStatus.chequeId ===
                                                      null
                                                        ? ""
                                                        : "-" +
                                                          invoiceStatus.chequeId)}
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  );
                                } else {
                                  return (
                                    <li>
                                      <div class="notification-time">
                                        <span class="date"></span>
                                        <span class="time">
                                          {moment(
                                            invoiceStatus.created_at,
                                          ).format("DD/MM/YYYY")}
                                        </span>
                                      </div>
                                      <div class="notification-icon">
                                        <a href="javascript:void(0);"></a>
                                      </div>
                                      <div class="notification-time-date mb-2 d-block d-md-none">
                                        <span class="date">Today</span>
                                        <span class="time ms-2">02:31</span>
                                      </div>
                                      <div class="notification-body">
                                        <div class="media mt-0">
                                          <div class="media-body ms-3 d-flex">
                                            <div class="">
                                              <p class="fs-18 text-dark fw-bold mb-0">
                                                {invoiceStatus.status.name}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  );
                                }
                              })}
                            </ul>
                          </div>
                        </div>
                        {/* annulation de dernier payement */}
                        {(invoiceStatusHistory.length > 1 ||
                          invoiceStatusHistory[invoiceStatusHistory.length - 1]
                            ?.status?.id !== 1) && (
                          <>
                            <div className="col-md-12">
                              <button
                                className="btn btn-danger m-10"
                                onClick={handleDeleteLastPayment}
                              >
                                Annuler le dernier paiement
                              </button>
                            </div>
                            <br />
                          </>
                        )}
                        {/* /////////////////////////////////// */}
                        <div className="invoiceStatus">
                          <span class="tag tag-rounded tag-icon tag-blue">
                            <i class="fe fe-bell"></i>Votre facture est
                            payé{" "}
                          </span>
                        </div>
                        <div className="form-group addPaymentStatus">
                          <label htmlFor="exampleInputEmail1" className="">
                            Etat*
                          </label>
                          <select
                            className="form-select"
                            id="buyPriceAccountInput"
                            onChange={(e) => setSelectedStatus(e.target.value)}
                            value={selectedStatus}
                          >
                            <option value="0">
                              sélectionner l'état de la facture
                            </option>
                            {invoiceStatus.map((status) => {
                              return (
                                <option value={status.id}>{status.name}</option>
                              );
                            })}
                          </select>
                        </div>
                        <div
                          className="paymentSection addPaymentStatus"
                          style={{
                            display:
                              selectedStatus === "2" || selectedStatus === "3"
                                ? "block"
                                : "none",
                          }}
                        >
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1" className="">
                              Date de règlement*
                            </label>
                            <input
                              type="date"
                              placeholder="nom"
                              className={`form-control `}
                              onChange={handleInvoiceStatusCreatedAtChange}
                              value={invoiceStatusCreatedAt}
                            />
                          </div>

                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1" className="">
                              Banque ou Caisse*
                            </label>
                            <select
                              className="form-select"
                              id="buyPriceAccountInput"
                              onChange={(e) => {
                                setPaymentType(e.target.value);
                                console.log("paymùslkdnb;s,:", e.target.value);
                              }}
                              value={paymentType}
                            >
                              <option value="0">
                                selectionner un mode de réglement
                              </option>
                              {banqueAccounts.map((account) => (
                                <option
                                  value={account.id}
                                  onClick={() => console.log("ffdfdfd")}
                                >
                                  {account.code + " - " + account.name}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div
                            className="form-group"
                            style={{
                              display:
                                paymentType === "" + bqAccountId + ""
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <label htmlFor="sousCompte" className="">
                              Sous Compte*
                            </label>
                            <select
                              className="form-select"
                              id="sousCompte"
                              onChange={(e) => {
                                setSousCompte(e.target.value);
                              }}
                              value={sousCompte}
                            >
                              <option value="0">
                                selectionner un sous compte
                              </option>
                              {sousComptes.map((account) => (
                                <option value={account.id}>
                                  {account.code + " - " + account.name}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div
                            className="form-group"
                            style={{
                              display:
                                paymentType === "" + caisseAccountId + ""
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <label htmlFor="sousCompteCs" className="">
                              Sous Compte*
                            </label>
                            <select
                              className="form-select"
                              id="sousCompteCs"
                              onChange={(e) => {
                                setSousCompteCs(e.target.value);
                              }}
                              value={sousCompteCs}
                            >
                              <option value="0">
                                selectionner un sous compte
                              </option>
                              {sousComptesCs.map((account) => (
                                <option value={account.id}>
                                  {account.code + " - " + account.name}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="banqueOptions">
                            <div
                              className="verementOrChéque"
                              style={{
                                display:
                                  paymentType === "" + bqAccountId + ""
                                    ? "block"
                                    : "none",
                              }}
                            >
                              <div className="form-group">
                                <label
                                  htmlFor="exampleInputEmail1"
                                  className=""
                                >
                                  Mode de règlement*
                                </label>
                                <select
                                  className="form-select"
                                  id="buyPriceAccountInput"
                                  onChange={(e) =>
                                    setBanquePaymentOption(e.target.value)
                                  }
                                  value={banquePaymentOption}
                                >
                                  <option value="0">
                                    selectionner un mode de réglement
                                  </option>
                                  <option value="virement">Virement</option>
                                  <option value="chéque">Chéque</option>
                                  <option value="carte bancaire">
                                    Carte Bancaire
                                  </option>
                                  <option value="effet">Effet</option>
                                  <option value="prélévement">
                                    Prélévement
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div
                              className="libelleIfcheque"
                              style={{
                                display:
                                  banquePaymentOption === "chéque" &&
                                  paymentType === "" + bqAccountId + ""
                                    ? "block"
                                    : "none",
                              }}
                            >
                              <div className="form-group">
                                <label
                                  htmlFor="exampleInputEmail1"
                                  className=""
                                >
                                  Identificateur du chéque*
                                </label>
                                <input
                                  type="text"
                                  placeholder=""
                                  className={`form-control `}
                                  onChange={(e) => setChequeId(e.target.value)}
                                  value={chequeId}
                                />
                              </div>
                            </div>
                            <div
                              className="libelleIfcheque"
                              style={{
                                display:
                                  banquePaymentOption === "effet" &&
                                  paymentType === "" + bqAccountId + ""
                                    ? "block"
                                    : "none",
                              }}
                            >
                              <div className="form-group">
                                <label
                                  htmlFor="exampleInputEmail1"
                                  className=""
                                >
                                  Identificateur d'effet*
                                </label>
                                <input
                                  type="text"
                                  placeholder=""
                                  className={`form-control `}
                                  onChange={(e) => setEffetId(e.target.value)}
                                  value={effetId}
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="form-group"
                            style={{
                              display:
                                selectedStatus === "3" ? "block" : "none",
                            }}
                          >
                            <label htmlFor="exampleInputEmail1" className="">
                              Montant payé*
                            </label>
                            <input
                              type="text"
                              placeholder="objet"
                              className={`form-control `}
                              onChange={(e) => {
                                if (
                                  e.target.value > summaryTotatlTtc ||
                                  e.target.value > invoiceRap
                                ) {
                                  setPayedAmount(0);
                                  toast.error(
                                    "le montant payé remplit est incohérent",
                                    {
                                      position: "top-right",
                                      autoClose: 5000,
                                      hideProgressBar: false,
                                      closeOnClick: true,
                                      pauseOnHover: false,
                                      draggable: true,
                                      progress: undefined,
                                      theme: "colored",
                                    },
                                  );
                                  // toast.error(
                                  //   "Si le montant payé égale le réste à payé veuillez changer le status de la facture à Payé",
                                  //   {
                                  //     position: "top-right",
                                  //     autoClose: 5000,
                                  //     hideProgressBar: false,
                                  //     closeOnClick: true,
                                  //     pauseOnHover: false,
                                  //     draggable: true,
                                  //     progress: undefined,
                                  //     theme: "colored",
                                  //   }
                                  // );
                                } else {
                                  setPayedAmount(e.target.value);
                                }
                              }}
                              value={payedAmount}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="row">
                <div class="col-md-12">
                  <button
                    disabled={isSubmit}
                    type="button"
                    className="btn btn-primary"
                    onClick={save}
                  >
                    {isSubmit ? t("Loading ...") : t("Enregistrer")}
                  </button>
                  <a
                    onClick={() => {
                      navigate(-1);
                    }}
                    className="btn btn-default float-end"
                  >
                    Annuler
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="offcanvas offcanvas-bottom addProductCanvas"
          tabIndex="-1"
          id="offcanvasBottom"
          aria-labelledby="offcanvasBottomLabel"
        >
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasBottomLabel">
              Renseigner le produit à ajouter.
            </h5>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i class="fe fe-x fs-18"></i>
            </button>
          </div>
          <div class="offcanvas-body">
            <div id="all-fields-are-required">
              <div
                class="alert alert-danger alert-dismissible fade show mb-0"
                role="alert"
              >
                <span class="alert-inner--icon">
                  <i class="fe fe-slash"></i>
                </span>
                <span class="alert-inner--text">
                  <strong>Attention!</strong> Tous les champs sont obligatoire !
                </span>
              </div>
              <br />
            </div>

            <div id="warning-product-already-exists">
              <div
                class="alert alert-danger alert-dismissible fade show mb-0"
                role="alert"
              >
                <span class="alert-inner--icon">
                  <i class="fe fe-slash"></i>
                </span>
                <span class="alert-inner--text">
                  <strong>Attention!</strong> Le produit déja exist !
                </span>
              </div>
              <br />
            </div>

            <div id="qty-is-higher">
              <div
                class="alert alert-danger alert-dismissible fade show mb-0"
                role="alert"
              >
                <span class="alert-inner--icon">
                  <i class="fe fe-slash"></i>
                </span>
                <span class="alert-inner--text">
                  <strong>Attention!</strong> L'article choisie est en rupture
                  de stock
                </span>
              </div>
              <br />
            </div>

            <form className="needs-validation" noValidate="">
              <div class="form-row">
                <div class="col-xl-12 mb-3">
                  <label
                    className={"select-article"}
                    htmlFor="validationTooltip01"
                  >
                    DÉTAILS DE L’ARTICLE*
                  </label>
                  <Select
                    className={"select-article"}
                    options={products}
                    onChange={(choice) => {
                      setSingleSelectedProduct(choice);
                      getProductData(choice);
                      if (!choice.isService) {
                        setIsService(false);
                      }
                    }}
                  />
                </div>
                <div className="col-xl-12 mb-3">
                  {/* {depotsProduct?.length > 0 && ( */}
                  {!isService && depotsProduct?.length > 0 && (
                    <>
                      <label htmlFor="productDepots">
                        {t("Dépôts disponibles")}
                      </label>
                      {depotsProduct?.map((depot, index) => (
                        <div key={index} className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            id={`depot-${index}`}
                            value={depot.depot_id}
                            name="productDepot"
                            checked={selectedDepotId == depot.depot_id}
                            onChange={(e) => {
                              setSelectedDepotId(e.target.value);
                              setSelectedProductQty(depot.quantity);
                              console.log("productDepot", e.target.value);
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`depot-${index}`}
                          >
                            {depot.depot.name}
                          </label>
                        </div>
                      ))}
                    </>
                  )}
                </div>
                <div class="col-xl-12 mb-3">
                  <label htmlFor="productDetails">Détails du produit</label>
                  <textarea
                    className="form-control"
                    id="productDetails"
                    rows="2"
                    value={productDetails}
                    onChange={(e) => setProductDetails(e.target.value)}
                  ></textarea>
                </div>
                <div className="col-xl-3 mb-3" hidden={isService}>
                  <label htmlFor="validationTooltip02">QUANTITÉ*</label>
                  <input
                    className="form-control"
                    id="validationTooltip02"
                    type="number"
                    required
                    value={qty}
                    onChange={(e) => {
                      $("#qty-is-higher").css("display", "none");

                      const inputValue = parseFloat(
                        parseFloat(e.target.value).toFixed(2),
                      );

                      if (isNaN(inputValue) || inputValue < 0) {
                        setQty(0);
                        setTotalHt(0);
                        setTotalTTC(0);
                        return;
                      }

                      // Calcule les valeurs
                      const totalHtl = parseFloat(
                        (inputValue * unitPrice).toFixed(2),
                      );
                      const totalTTC = parseFloat(
                        (totalHtl + (totalHtl * tva) / 100).toFixed(2),
                      );

                      // Met à jour l'état
                      setQty(inputValue);
                      setTotalHt(totalHtl);
                      setTotalTTC(totalTTC);
                    }}
                  />
                </div>
                <div class="col-xl-3 mb-3">
                  <label htmlFor="validationTooltip02">PU HT*</label>
                  <input
                    type="number"
                    className="form-control"
                    id="validationTooltip02"
                    required=""
                    value={unitPrice}
                    onChange={(e) => {
                      const value = parseFloat(e.target.value);

                      if (!isNaN(value)) {
                        if (isService) {
                          setUnitPrice(parseFloat(value.toFixed(2)));
                        } else {
                          const total_ht = qty * value;
                          const total_ttc = parseFloat(
                            (total_ht + (total_ht * tva) / 100).toFixed(2),
                          );
                          setUnitPrice(parseFloat(value.toFixed(2)));
                          setTotalHt(parseFloat(total_ht.toFixed(2)));
                          setTotalTTC(total_ttc);
                        }
                      }
                    }}

                    // disabled={!isService}
                  />
                </div>
                <div className="col-xl-3 mb-3">
                  <label htmlFor="validationTooltip02">Total HT*</label>
                  <input
                    type="text"
                    className="form-control"
                    id="validationTooltip02"
                    required=""
                    value={isService ? unitPrice.toFixed(2) : totalHt}
                    ref={leTotalHt}
                  />
                </div>
                <div className="col-xl-3 mb-3">
                  <label htmlFor="validationTooltip02">Total TTC*</label>
                  <input
                    type="number"
                    className="form-control"
                    id="validationTooltip02"
                    required=""
                    value={
                      isService
                        ? (
                            parseFloat(unitPrice.toFixed(2)) +
                            (parseFloat(unitPrice.toFixed(2)) * tva) / 100
                          ).toFixed(2)
                        : totalTTc
                    }
                    ref={leTotalTTc}
                  />
                </div>
              </div>
              <i
                className="fe fe-plus btn btn-primary add-new-product-to-invoice-btn"
                onClick={addNewProductToInvoice}
              ></i>
              <i
                className="fe fe-edit btn btn-primary edit-single-product"
                onClick={editSingleInvoiceProduct}
              ></i>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditInvoiceAchat;
